import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnalytics from "vue-analytics";
import "@/assets/css/app.css";

Vue.config.productionTip = false;

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: "UA-61178178-1",
  router
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

document.oncontextmenu = new Function("return false");

// Scroll to top since router changed
router.beforeEach(function(to, from, next) {
  window.scrollTo(0, 0);
  next();
});
